import { computeCOIItems } from "./costs";

function firstText(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
}

function hasReportableValue(item = {}) {
  const label = firstText(
    item.firm,
    item.description,
    item.name,
    item.type
  );
  return !!label || (item.amount !== "" && item.amount != null);
}

function buildLabel(item = {}) {
  const type = firstText(item.type);
  const description = firstText(item.firm, item.description, item.name);

  if (type && description) return `${type} – ${description}`;
  return type || description || "Other COI";
}

export function buildCostOfIssuanceReport(items = [], parAmount = 0) {
  const par = Number(parAmount) || 0;
  const rows = computeCOIItems(items, par)
    .filter(hasReportableValue)
    .map((item) => {
      const amount = Number(item.computedAmount) || 0;
      return {
        label: buildLabel(item),
        percentOfPar: par > 0 ? (amount / par) * 100 : null,
        amount,
      };
    });

  const totalAmount = rows.reduce((sum, row) => sum + row.amount, 0);

  return {
    rows,
    total: {
      label: "Total",
      percentOfPar: par > 0 ? (totalAmount / par) * 100 : null,
      amount: totalAmount,
      isTotal: true,
    },
  };
}
